const state = {
    isVertical: JSON.parse(localStorage.getItem("isVertical")) ?? true,
    fromSet:'' // Initial value
  };
  
  const mutations = {
    TOGGLE_HEADER(state,value) {
      state.fromSet = value
      state.isVertical = !state.isVertical;
      localStorage.setItem("isVertical", JSON.stringify(state.isVertical));
    },
    SET_HEADER(state, value) {
        state.isVertical = value;
        localStorage.setItem("isVertical", JSON.stringify(value)); // Save to localStorage
      },
  };
  
  const actions = {
    toggleHeader({ commit }, data) {
      commit("TOGGLE_HEADER", data);
    },
    setHeader({ commit }, value) {
        commit("SET_AA", value);
      },
  };
  
  const getters = {
    getHeader: (state) => state.isVertical,
    getHeaderFrom: (state) => state.fromSet
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  